import { Component, OnDestroy } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { VideoService } from "./services/video.service";
import { VideoModalComponent } from "./components/common/video-modal/video-modal.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnDestroy {
  title = "virsa";
  showDefaultLayout = true;

  private videoSub: Subscription;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private videoService: VideoService
  ) {
    // Route change handler
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // scroll to top
        window.scrollTo(0, 0);

        // show or hide default layout based on route
        var linkUrl = event.urlAfterRedirects;

        var isPresent = linkUrl.startsWith("/international-class");
        if (!isPresent) {
          isPresent = linkUrl.startsWith("/login");
        }

        this.showDefaultLayout = !isPresent;
      }
    });

    // Listen for "Play Video" trigger from IndusLabs chatbot agent
    // Triggered via LiveKit DataReceived event (parsed in ai-chat-widget.component.ts)
    // or via: window.dispatchEvent(new CustomEvent('induslabs_play_video', { detail: { url, title } }))
    this.videoSub = this.videoService.playVideo$.subscribe(({ url, title }) => {
      this.dialog.open(VideoModalComponent, {
        enterAnimationDuration: "400ms",
        maxWidth: "90vw",
        width: "780px",
        panelClass: "video-dialog-panel",
        data: {
          title: title,
          video: url,
          discription: "",
          youtube: true,
        },
      });
    });
  }

  ngOnDestroy(): void {
    this.videoSub?.unsubscribe();
  }
}
